import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ItemContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const ItemBox = styled.div`
	display: block;
	width: 45rem;
	border: 1px solid var(--border-color);
	border-radius: 0.5rem;
	padding: 1rem;
	margin: auto;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	@media ${Breakpoints.mobile} {
		width: 45rem;
	}
`;
